import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { UntilDestroy } from "@ngneat/until-destroy";
import { HaUiCommonModule } from "@ha/ui/common";
import { HaUiFormsModule } from "@ha/ui/forms";
import { HaUiNavigationModule } from "@ha/ui/navigation";
import { HaUtilPipesModule } from "@ha/util/pipes";
import { TranslocoModule } from "@ngneat/transloco";

import { ApplicationPaths } from "../constants/application-paths";
import { LoginMfaSetupComponent } from "./components/login-mfa-setup.component";
import { LoginMfaVerificationComponent } from "./components/login-mfa-verification.component";
import { MfaService } from "@ha/feature/mfa";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,
        TranslocoModule,
        HaUiCommonModule,
        HaUiFormsModule,
        HaUtilPipesModule,
        HaUiNavigationModule,

        RouterModule.forChild([
            { path: ApplicationPaths.MfaSetup, component: LoginMfaSetupComponent },
            { path: ApplicationPaths.MfaVerification, component: LoginMfaVerificationComponent },
        ]),
    ],
    declarations: [LoginMfaSetupComponent, LoginMfaVerificationComponent],
    exports: [LoginMfaSetupComponent, LoginMfaVerificationComponent],
    providers: [MfaService],
})
export class IdentityMfaModule { }
